module.exports = __webpack_public_path__ + "media/images/sw_logo-5f6f0b23835db6560fe9922365aa6f91.svg";